import { render, staticRenderFns } from "./lawCase.vue?vue&type=template&id=78970787&scoped=true&"
import script from "./lawCase.vue?vue&type=script&lang=js&"
export * from "./lawCase.vue?vue&type=script&lang=js&"
import style0 from "./lawCase.vue?vue&type=style&index=0&id=78970787&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78970787",
  null
  
)

export default component.exports